
import { CommonModule } from "@angular/common";
import { Component, HostListener } from "@angular/core";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { CommonSvgIconComponent } from "../../../shared/components/common-svg-icon/common-svg-icon.component";
import { FeatherIconsComponent } from "../../../shared/components/feather-icons/feather-icons.component";
import { TranslateModule } from "@ngx-translate/core";
import { LayoutService } from "../../../shared/services/layout.service";
import { Menu } from "../../../models/menu.model";
import { SuperAdminNavService } from "../../../shared/services/superadmin_nav.service";


@Component({
  selector: "app-superadmin-sidebar",
  templateUrl: './superadmin-sidebar.component.html',
  imports: [RouterModule, CommonSvgIconComponent, FeatherIconsComponent,
    CommonModule, TranslateModule],
  styleUrls: ["./superadmin-sidebar.component.scss"]
})

export class SuperadminSidebarComponent {

  public leftArrowNone: boolean = true;
  public rightArrowNone: boolean = false;
  public margin: number = 0;
  public width: number = window.innerWidth;
  public menuItemsList = this.navService.MENUITEMS;
  public pinnedData: boolean = false;
  public pinnedDataList: string[] = [];

  constructor(
    private router: Router,
    public navService: SuperAdminNavService,
    public layoutService: LayoutService
  ) {
    this.navService.items.subscribe((menuItems) => {
      this.menuItemsList = menuItems;
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.menuItemsList.filter((items: Menu) => {
            if (items.path === event.url) {
              this.setNavActive(items);
            }
            if (!items.children) {
              return false;
            }
            items.children.filter((subItems: Menu) => {
              if (subItems.path === event.url) {
                this.setNavActive(subItems);
              }
              if (!subItems.children) {
                return false;
              }
              subItems.children.filter((subSubItems: Menu) => {
                if (subSubItems.path === event.url) {
                  this.setNavActive(subSubItems);
                }
              });
              return;
            });
            return;
          });
        }
      });
    });
  }

  isPined(itemName: string | undefined): boolean {
    return itemName !== undefined && this.pinnedDataList?.includes(itemName);
  }

  pinned(title: string) {
    const index = this.pinnedDataList.indexOf(title);
    if (index !== -1) {
      this.pinnedDataList.splice(index, 1);
    } else {
      this.pinnedDataList.push(title);
    }
    if (this.pinnedDataList.length <= 0) {
      this.pinnedData = false;
    } else {
      this.pinnedData = true;
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: { target: { innerWidth: number } }) {
    this.width = event.target.innerWidth - 500;
  }

  setNavActive(item: Menu) {
    this.menuItemsList.filter(menuItem => {
      if (menuItem !== item) {
        menuItem.active = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          } else {
            submenuItems.active = false;
          }
        });
      }
    });
  }

  sidebarToggle() {
    this.navService.collapseSidebar = !this.navService.collapseSidebar;
  }

  toggletNavActive(item: Menu) {
    if (!item.active) {
      this.menuItemsList.forEach((a: Menu) => {
        if (this.menuItemsList.includes(item)) {
          a.active = false;
        }
        if (!a.children) {
          return false;
        }
        a.children.forEach((b: Menu) => {
          if (a.children?.includes(item)) {
            b.active = false;
          }
        });
        return;
      });
    }
    item.active = !item.active;
  }

  scrollToLeft() {
    if (this.margin >= -this.width) {
      this.margin = 0;
      this.leftArrowNone = true;
      this.rightArrowNone = false;
    } else {
      this.margin += this.width;
      this.rightArrowNone = false;
    }
  }

  scrollToRight() {
    if (this.margin <= -3500) {
      this.margin = -3000;
      this.leftArrowNone = false;
      this.rightArrowNone = true;
    } else {
      this.margin += -this.width;
      this.leftArrowNone = false;
    }
  }

  closeSidebar(item: Menu) {
    if (item && item.path) {
      if (!this.navService.collapseSidebar && window.innerWidth < 1200) {
        this.navService.collapseSidebar = true;
      }
    }
  }
}
